module.exports = __webpack_public_path__ + "static/media/13@720w.6278c6de.jpg";